import React from "react";
import { Link } from "react-router-dom";

function WorkspaceModuleNoPermission(props) {

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="bg-white alert alert-danger" role="alert">
          <h4 className="alert-heading">Permission Denied!</h4>
          <p>
            Looks like you don&apos;t have enough permission to access this feature
            or resource.
          </p>
          <hr />

          <br />
          <p className="mb-0">
            If you are lost , Please click&nbsp;
            <Link
              to={'/dashboard'}
              style={{ cursor: "pointer" }}
            >
              here
            </Link>
            &nbsp;to go back to dashboard
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default WorkspaceModuleNoPermission;
